module.exports = __webpack_public_path__ + "img/SOFTWARE_MV.9b134029.png";